import _ from 'underscore';

import {omitNull} from 'common/utils';


export default class ServiceRegion {
  /* eslint-disable camelcase */
  constructor({
    region_id,
    pickup,
    dropoff,
  }) {
    this.type = 'region';
    this.region_id = region_id || null;
    this.pickup = pickup || false;
    this.dropoff = dropoff || false;
  }
  /* eslint-enable camelcase */

  clone() {
    return new ServiceRegion(this.serialize());
  }

  serialize() {
    return omitNull({
      region_id: this.region_id,
      pickup: this.pickup,
      dropoff: this.dropoff,
    });
  }

  isDifferent(other) {
    return !_.isEqual(this.serialize(), other.serialize());
  }
}



// WEBPACK FOOTER //
// ./src/common/types/ServiceRegion.js